import React, { useState } from 'react'

import AIpopup from '../../../../components/AIPopup/AIpopup';

import { ReactComponent as NewsAiIcon } from '../../../../assets/images/newsAiIcon.svg';
import { ReactComponent as NewsArrow } from '../../../../assets/images/NewsArrow.svg'
import styles from './styles/SingleNewsCard.module.scss'

function SingleNewsCard({ news, colors }) {

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <div
      className={styles.postCard}
      style={{
        '--card-border-color': colors.border,
        '--secondary-color': colors.secondary,
        '--ai-border-color': colors.aiColor,
        "--ai-button-text": colors.aiButtonTextColor,
        "--ai-button-text": colors?.aiButtonTextColor,
        "--icon-gradient-1": colors.aiIconColors[0],
        "--icon-gradient-2": colors.aiIconColors[1],
        "--icon-gradient-3": colors.aiIconColors[2],
        "--icon-gradient-4": colors.aiIconColors[3] || "#D61663",
      }}
    >
      <div className={styles.imageContainer}>
        <img src={news?.featured_image?.file} alt={news?.featured_image?.alternative_text} />
        <a href={`/news/${news?.slug}`}>
          <span className={styles.expandIcon}><NewsArrow /></span>
        </a>
      </div>
      <div className={styles.content}>
        <span className={styles.date}>{new Date(news.publish_date).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })}</span>
        <h3>{news.title}</h3>
        <p>{news.excerpt}</p>
        <div className={styles.actions}>
          <div className={styles.urlWrapper}>
            <a href={`/news/${news?.slug}`}>Read more</a>↗
          </div>

          {news.ai_summary && Object.keys(news.ai_summary).length > 0 && (
            <button className={styles.aiBtn} onClick={setIsPopupOpen}>
              <NewsAiIcon /> Ai
            </button>
          )}
        </div>
      </div>
      {
        isPopupOpen && (
          <AIpopup
            popupOpen={isPopupOpen}
            setPopupStatus={setIsPopupOpen}
            data={news.ai_summary}
            newsTitle={news.title}
          />
        )
      }
    </div>
  )
}

export default SingleNewsCard